import './ProgressBar.scss';

const barContainerWidth = 174; /* same value in the ProgressBar.scss */

function ProgressBar({ steps, currentStep }) {
  const barWidth = barContainerWidth / steps;
  let barStyle = {
    height: 10,
    width: barWidth,
    borderRight: '1px solid var(--color-main-orange)',
  };
  const completedBarStyle = {
    ...barStyle,
    backgroundColor: 'var(--color-main-orange)',
  };
  const uncompletedBarStyle = {
    ...barStyle,
    backgroundColor: 'var(--color-white)',
  };

  let bars = [];
  for (let i = 1; i <= steps; i++) {
    let style = i <= currentStep ? completedBarStyle : uncompletedBarStyle;
    if (i === steps) {
      style = { ...style, borderRight: 'none' };
    }
    bars.push(<div key={i} style={style}></div>);
  }

  return (
    <div className="ProgressBar-container">
      <div className="ProgressBar-barContainer">{bars}</div>
      <p className="ProgressBar-text">{`Krok ${currentStep} z ${steps}`}</p>
    </div>
  );
}

export default ProgressBar;
